import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import Modal from "./Modal";

const ConfirmationDialog = ({
  isVisible,
  onClose,
  onConfirm,
  title,
  description,
  isSubmitting,
}) => {
  return (
    <Modal
      startIcon={
        <div className="p-2 rounded-xl border">
          <ExclamationTriangleIcon className="size-6" />
        </div>
      }
      open={isVisible}
      onClose={onClose}
      onSubmit={onConfirm}
      title={title}
      description={description}
      isSubmitting={isSubmitting}
    />
  );
};

export default ConfirmationDialog;
